// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.


// Selecciona todos los elementos <audio> en la página
const audios = document.querySelectorAll('audio');

// Añade un evento 'play' a cada uno
audios.forEach(audio => {
  audio.addEventListener('play', () => {
    // Detiene los otros audios que estén sonando
    audios.forEach(otherAudio => {
      if (otherAudio !== audio) {
        otherAudio.pause();
        otherAudio.currentTime = 0; // Reinicia el audio
      }
    });
  });
});
